import { OverviewDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/store/overviewDashboard.store.types';
import {
  getThresholdLevel,
  SHIFT_STATUS_CATEGORIES,
  ShiftStatusKey,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.constants';

const SHIFT_BREAKDOWN_STUB_VALUES: Record<ShiftStatusKey, { count: number; percentage: number }> = {
  assigned: { count: 1234, percentage: 67 },
  fulfilled_callout: { count: 276, percentage: 15 },
  upcoming_callout: { count: 0, percentage: 0 },
  fulfilled_bid_award: { count: 184, percentage: 10 },
  pending: { count: 0, percentage: 0 },
  unfulfilled: { count: 92, percentage: 5 },
  cancelled: { count: 56, percentage: 3 },
  absent: { count: 0, percentage: 0 },
};

const FULFILLMENT_BY_POSITION_STUB = [
  { position: 'Wellness Nurse', fulfillmentPercentage: 88, totalShifts: 520 },
  { position: 'Medication Care Partner', fulfillmentPercentage: 84, totalShifts: 380 },
  { position: 'Resident Care Partner (PSW)', fulfillmentPercentage: 79, totalShifts: 480 },
  { position: 'Housekeeper', fulfillmentPercentage: 76, totalShifts: 280 },
  { position: 'Server', fulfillmentPercentage: 72, totalShifts: 182 },
];

export const OVERVIEW_DATA_LOCKED_STUB: Partial<OverviewDashboardStore> = {
  totalShifts: 1842,
  periodDays: 7,
  changePrct: 3,
  calloutHoursTotal: 2218,
  calloutHoursPeriodDays: 7,
  calloutHoursChangePrct: -5,
  fulfillmentPrctTotal: 82.4,
  fulfillmentPrctPeriodDays: 7,
  fulfillmentPrctChangePrct: 2.1,
  activeTeamMembersTotal: 140,
  activeTeamMembersPeriodDays: 7,
  activeTeamMembersChangePrct: 1,
  shiftBreakdown: SHIFT_STATUS_CATEGORIES.map(({ key, i18nKey }) => ({
    category: i18nKey,
    count: SHIFT_BREAKDOWN_STUB_VALUES[key].count,
    percentage: SHIFT_BREAKDOWN_STUB_VALUES[key].percentage,
  })),
  fulfillmentByPosition: FULFILLMENT_BY_POSITION_STUB.map((item) => ({
    ...item,
    thresholdLevel: getThresholdLevel(item.fulfillmentPercentage),
  })),
  callOutByLocation: [
    { locationName: 'Seasons Amherstburg', locationId: '1', callOutCount: 82 },
    { locationName: 'Seasons Owen Sound', locationId: '2', callOutCount: 68 },
    { locationName: 'Seasons Cambridge', locationId: '3', callOutCount: 54 },
  ],
  trendData: [
    { date: '2026-05-04', totalShifts: 220, fulfillmentPercentage: 82 },
    { date: '2026-05-05', totalShifts: 235, fulfillmentPercentage: 84 },
    { date: '2026-05-06', totalShifts: 228, fulfillmentPercentage: 81 },
    { date: '2026-05-07', totalShifts: 260, fulfillmentPercentage: 83 },
    { date: '2026-05-08', totalShifts: 248, fulfillmentPercentage: 80 },
    { date: '2026-05-09', totalShifts: 272, fulfillmentPercentage: 78 },
    { date: '2026-05-10', totalShifts: 259, fulfillmentPercentage: 76 },
  ],
  trendGranularity: 'daily',
};
